import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SendIcon, CheckCircleIcon } from 'lucide-react';
export function ContactFormSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // TODO: Integrate EmailJS here
    // emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target as HTMLFormElement, 'YOUR_PUBLIC_KEY')
    // Simulating API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <section id="contact-form" className="py-24 px-6 bg-carbon border-t border-carbon-lighter scroll-mt-20" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-13">
            Da el primer paso hacia la{' '}
            <span className="text-gold" data-id="element-14">estabilidad</span>
          </h2>
          <p className="text-neutral-400 font-body text-lg" data-id="element-15">
            Completa el formulario para solicitar tu diagnóstico gratuito.
            Analizaremos tu negocio y te mostraremos el plan exacto para
            conseguir contratos recurrentes.
          </p>
        </motion.div>

        {isSuccess ? <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-emerald/10 border border-emerald/30 rounded-2xl p-12 text-center" data-id="element-16">
            <CheckCircleIcon className="w-20 h-20 text-emerald mx-auto mb-6" data-id="element-17" />
            <h3 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-18">
              ¡Solicitud Recibida!
            </h3>
            <p className="text-neutral-300 font-body" data-id="element-19">
              Nos pondremos en contacto contigo muy pronto para agendar tu
              diagnóstico.
            </p>
          </motion.div> : <motion.form initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} onSubmit={handleSubmit} className="bg-carbon-light p-6 md:p-10 rounded-2xl border border-carbon-lighter shadow-2xl space-y-6" data-id="element-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21">
              <div className="space-y-2" data-id="element-22">
                <label className="text-sm font-body text-neutral-300" data-id="element-23">
                  Nombre Completo *
                </label>
                <input required type="text" name="user_name" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="Ej. Juan Pérez" data-id="element-24" />
              </div>
              <div className="space-y-2" data-id="element-25">
                <label className="text-sm font-body text-neutral-300" data-id="element-26">
                  Email *
                </label>
                <input required type="email" name="user_email" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="juan@empresa.com" data-id="element-27" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-28">
              <div className="space-y-2" data-id="element-29">
                <label className="text-sm font-body text-neutral-300" data-id="element-30">
                  Número de Teléfono *
                </label>
                <input required type="tel" name="user_phone" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="(555) 123-4567" data-id="element-31" />
              </div>
              <div className="space-y-2" data-id="element-32">
                <label className="text-sm font-body text-neutral-300" data-id="element-33">
                  Nombre de la Compañía *
                </label>
                <input required type="text" name="company_name" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="Ej. Green Landscaping" data-id="element-34" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-35">
              <div className="space-y-2" data-id="element-36">
                <label className="text-sm font-body text-neutral-300" data-id="element-37">
                  Instagram de la Compañía
                </label>
                <input type="text" name="company_instagram" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="@tu_empresa" data-id="element-38" />
              </div>
              <div className="space-y-2" data-id="element-39">
                <label className="text-sm font-body text-neutral-300" data-id="element-40">
                  Sitio Web (si tienes)
                </label>
                <input type="url" name="company_website" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="https://www.tuempresa.com" data-id="element-41" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-42">
              <div className="space-y-2" data-id="element-43">
                <label className="text-sm font-body text-neutral-300" data-id="element-44">
                  ¿Cuántos clientes tienes por semana?
                </label>
                <select name="current_clients" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors appearance-none" data-id="element-45">
                  <option value="" data-id="element-46">Selecciona una opción</option>
                  <option value="0-10" data-id="element-47">0 - 10</option>
                  <option value="11-30" data-id="element-48">11 - 30</option>
                  <option value="31-50" data-id="element-49">31 - 50</option>
                  <option value="50+" data-id="element-50">Más de 50</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-51">
                <label className="text-sm font-body text-neutral-300" data-id="element-52">
                  ¿Cuál es tu meta semanal de clientes nuevos?
                </label>
                <select name="goal_clients" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors appearance-none" data-id="element-53">
                  <option value="" data-id="element-54">Selecciona una opción</option>
                  <option value="1-5" data-id="element-55">1 - 5 nuevos</option>
                  <option value="6-15" data-id="element-56">6 - 15 nuevos</option>
                  <option value="16-30" data-id="element-57">16 - 30 nuevos</option>
                  <option value="30+" data-id="element-58">Más de 30 nuevos</option>
                </select>
              </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-carbon-lighter" data-id="element-59">
              <label className="text-sm font-body text-neutral-300 block" data-id="element-60">
                ¿Has hecho publicidad antes (Facebook/Google Ads)?
              </label>
              <div className="flex gap-6" data-id="element-61">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-62">
                  <input type="radio" name="has_run_ads" value="yes" className="text-gold focus:ring-gold bg-carbon border-carbon-lighter" data-id="element-63" />
                  <span className="text-white font-body" data-id="element-64">Sí</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-65">
                  <input type="radio" name="has_run_ads" value="no" className="text-gold focus:ring-gold bg-carbon border-carbon-lighter" data-id="element-66" />
                  <span className="text-white font-body" data-id="element-67">No</span>
                </label>
              </div>
            </div>

            <div className="space-y-2" data-id="element-68">
              <label className="text-sm font-body text-neutral-300" data-id="element-69">
                Si respondiste sí, ¿Cuánto has gastado aproximadamente?
              </label>
              <input type="text" name="ad_spend" className="w-full bg-carbon border border-carbon-lighter rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="Ej. $500/mes" data-id="element-70" />
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-carbon font-heading font-bold text-lg px-8 py-4 rounded-xl transition-all duration-300 mt-8 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-71">
              {isSubmitting ? 'ENVIANDO...' : 'ENVIAR SOLICITUD'}
              {!isSubmitting && <SendIcon className="w-5 h-5" data-id="element-72" />}
            </button>
          </motion.form>}
      </div>
    </section>;
}